import React, { useState } from 'react'
import MainCard from 'components/MainCard'
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, Button,
    Grid, Typography,FormControl, InputAdornment, OutlinedInput
} from '@mui/material';
import { SearchOutlined } from '@ant-design/icons';
import { Editplan } from './Editplan';
import { useGetAllPlansQuery} from 'services/userPlan-service';
import DeletePlanConfirmation from 'pages/components/DeleteConformation/DeletePlanConfirmation';
import { editPlanFields } from 'config';

export const UserPlan = () => {

    const [deleteConformation, setDeleteConformation] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialog, setDialog] = useState('Add');
    const [editData, setEditData] = useState(null);
    const [selectedUserId, setSelectedUserId] = useState(null)

    const { data,refetch } = useGetAllPlansQuery();
    const plans = data?.whitelabelPartnerPlan || [];
    const [searchTerm, setSearchTerm] = useState("");

    const filterPlans = plans.filter(plan =>
        Object.values(plan).some(value =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
    )   

    const handleDelete =async (id) => {
        setSelectedUserId(id);
        setDeleteConformation(true);
    }

    const handleCloseDeleteConformation = () => {
        setDeleteConformation(false);
        setSelectedUserId(null);
    };

    const handleOpenAddPlan = async () => {
        setDialog('add');
        setEditData(null);
        setOpenDialog(true);
    };   

    const handleOpenEditPlan = (plan) => {
        setDialog('edit')
        setEditData({...plan, yearlyPrice:plan.yearlyPrice.$numberDecimal || 0})
        setOpenDialog(true);
    }

    const handleCloseDialog = () => {
        setOpenDialog(false)
        setEditData(null);
    }
    
    return (
        <>
            <Grid container gap={3}>
                <Grid item xs={12}>       
                    <Typography
                        sx={{
                            color: "#28287B",
                            fontSize: "30px",
                            fontWeight: 600,
                            lineHeight: "28px",
                            letterSpacing: "0px",
                        }}>Partner Plan
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <MainCard content={false}>
                        <Box sx={{ width: '60%', padding: 2, display: 'flex', gap: 5, justifyContent: 'space-between' }}>
                            <FormControl>
                                <OutlinedInput
                                    size="small"
                                    startAdornment={
                                        <InputAdornment position="start" sx={{ mr: -0.5 }}>
                                            <SearchOutlined />
                                        </InputAdornment>
                                    }
                                    placeholder="Search"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </FormControl>
                            <Button sx={{
                                width: '30%',
                                backgroundColor: '#216fed',
                                color: '#ffffff',
                                border: 'none',
                                padding: '4 12',
                                fontSize: '14',
                                cursor: 'pointer',
                                '&:hover': {
                                    backgroundColor: '#216fed',
                                },
                            }} onClick={handleOpenAddPlan}>Add plan</Button>
                        </Box>
                        <Box
                            sx={{
                                border: '1 solid #ebebeb',
                                borderRadius: '12',
                                width: { xs: '100%' },
                            }}
                        >
                            <TableContainer
                                sx={{
                                    width: '100%',
                                    overflowx: 'auto',
                                    maxHeight: '100vh',
                                    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                                    boxShadow: 'rgb(234, 236, 240) 0 0 1, rgba(29, 41, 57, 0.08) 0 1 2',
                                    borderRadius: '6',
                                    color: 'rgb(16, 24, 40)',
                                    '& td, & th': { whiteSpace: 'nowrap' }
                                }}
                            >
                                <Table
                                    aria-labelledby="tableTitle"
                                    sx={{
                                        '& .MuiTableCell-root:first-of-type': {
                                            pl: 2,
                                        },
                                        '& .MuiTableCell-root:last-of-type': {
                                            pr: 3,
                                        },
                                    }}
                                    stickyHeader
                                >
                                    <TableHead >
                                        <TableRow>
                                            {editPlanFields[0].textFields.map((headCell, id) => (
                                                <TableCell
                                                    key={id}
                                                    sx={{
                                                        backgroundColor: 'rgb(242, 244, 246)',
                                                        color: 'rgb(40, 40, 123)',
                                                        fontSize: '13',
                                                        fontWeight: '500',
                                                    }}
                                                >
                                                    {headCell.label}
                                                </TableCell>
                                            ))}
                                            <TableCell sx={{
                                                backgroundColor: 'rgb(242, 244, 246)',
                                                color: 'rgb(40, 40, 123)',
                                                fontSize: '13',
                                                fontWeight: '500',
                                            }}>Edit</TableCell>
                                            <TableCell sx={{
                                                backgroundColor: 'rgb(242, 244, 246)',
                                                color: 'rgb(40, 40, 123)',
                                                fontSize: '13',
                                                fontWeight: '500',
                                            }}>Delete</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filterPlans.map((plan) => (
                                            <TableRow key={plan._id}>
                                                    <TableCell>{plan.planName}</TableCell>
                                                    <TableCell>{plan.activeLeads}</TableCell>
                                                    <TableCell>{plan.monthlyEmails}</TableCell>
                                                    <TableCell>{plan.aiWriterCredits}</TableCell>
                                                    <TableCell>{plan.leadsCredits}</TableCell>
                                                    <TableCell>{plan.bounceCredit}</TableCell>
                                                    <TableCell>{plan.linkedinCredits}</TableCell>
                                                    <TableCell>{plan.dailyLeadLimit}</TableCell>
                                                    <TableCell>{plan.emailAccountsLimit}</TableCell>
                                                    <TableCell>{plan.savedContacts}</TableCell>
                                                    <TableCell>{plan.dealPipeline}</TableCell>
                                                    <TableCell>{plan.dataEnrichmentCredits}</TableCell>
                                                    <TableCell>{plan.buyerIntendDataTopiscs}</TableCell>
                                                    <TableCell>{plan.yearlyPrice.$numberDecimal}</TableCell>
                                                <TableCell>
                                                    <Button onClick={() => handleOpenEditPlan(plan)} sx={{
                                                        backgroundColor: '#216fed', color: '#fff', '&:hover': {
                                                            backgroundColor: '#216fed',
                                                        },
                                                    }}>
                                                        Edit
                                                    </Button>
                                                </TableCell>
                                                <TableCell>
                                                    <Button onClick={() => handleDelete(plan._id)} sx={{
                                                        backgroundColor: '#ff0000', color: '#fff', '&:hover': {
                                                            backgroundColor: '#ff0000',
                                                        },
                                                    }}>
                                                        Delete
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </MainCard>
                </Grid>
            </Grid>
            <DeletePlanConfirmation open={deleteConformation} onClose={handleCloseDeleteConformation} userId={selectedUserId} refetch={refetch}/>
            <Editplan open={openDialog} onClose={handleCloseDialog} mode={dialog} data={editData} refetch={refetch} />
        </>
    )
}
